import {
  CreateJobCatalogTreeNodeDocument,
  CreateJobCatalogTreeNodeMutation,
  NodePageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateJobCatalogTreeNode = () => {
  const [mutate, { loading }] = useMutation(CreateJobCatalogTreeNodeDocument, {
    extractorFn: (data: CreateJobCatalogTreeNodeMutation) =>
      data.jobCatalogMutations.createJobcatalogTreeNode,
  })

  const createNode = (
    companyId: number,
    description: string,
    name: string,
    nodeType: string,
    parentId: number,
    parentNodeType: string
  ) => {
    return mutate({
      variables: {
        companyId,
        description,
        name,
        nodeType,
        parentId,
      },
      refetchQueries: [
        {
          query: NodePageDocument,
          variables: {
            nodeId: parentId,
            nodeType: parentNodeType,
          },
        },
      ],
    })
  }

  return { createNode, loading }
}

export default useCreateJobCatalogTreeNode
